'use client';

import { memo, useEffect, useState } from 'react';

import { Button } from '@heroui/react';
import { BiArrowToBottom, BiArrowToTop } from 'react-icons/bi';

import { v4 as uuidv4 } from 'uuid';

import core from '@/features/v2/home/components/localization/core';

import { useLocalStorage } from '@/hooks/usePerformance';

const Description = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [storedExpanded, setStoredExpanded] = useLocalStorage('description-expanded', false);

  useEffect(() => {
    setIsExpanded(storedExpanded);
  }, [storedExpanded]);

  const toggleExpanded = () => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    setStoredExpanded(newExpanded);
  };

  return (
    <section className="flex flex-col gap-4 relative justify-center items-center mt-4 md:mt-6 mx-4 font-text">
      <div className="flex flex-col gap-4 max-w-4xl">
        <header>
          <h2 className="text-xl md:text-2xl font-bold text-white text-center">
            {core.public.descriptionSection.title}
            {' '}
            <span className="text-primary-500">{core.public.descriptionSection.span}</span>
          </h2>
        </header>

        <div className="text-sm text-gray-300 leading-relaxed">
          <p className="mb-4">{core.public.descriptionSection.description}</p>

          {isExpanded && (
            <>
              <p className="mb-4">{core.public.descriptionSection.description3}</p>

              <h3 className="text-lg font-bold text-white mb-2">Deportes disponibles:</h3>
              <ul className="list-disc list-inside mb-4 space-y-1">
                {core.public.descriptionSection.list.map((sport) => {
                  return (
                    <li key={uuidv4()} className="text-gray-300">{sport}</li>
                  );
                })}
              </ul>

              <p className="mb-4">{core.public.descriptionSection.description4}</p>
              <p className="mb-4">{core.public.descriptionSection.description5}</p>
              <p className="mb-4">{core.public.descriptionSection.description6}</p>
              <p className="mb-4">{core.public.descriptionSection.description7}</p>
              <p className="mb-4">{core.public.descriptionSection.description8}</p>
              <p className="mb-4">{core.public.descriptionSection.description9}</p>

              <ol className="list-decimal list-inside mb-4 space-y-2">
                {core.public.descriptionSection.list2.map((step) => {
                  return (
                    <li key={uuidv4()} className="text-gray-300">{step}</li>
                  );
                })}
              </ol>
              {!isExpanded && <div className="fade-bottom z-50" />}
            </>
          )}
        </div>
        <div className="flex justify-center -mt-8 font-text">
          <Button
            size="sm"
            variant="ghost"
            onPress={toggleExpanded}
            className="bg-gradient-to-tr from-gradient-50 to-gradient-100 text-transparent bg-clip-text text-sm border-b border-gradient-100 px-0 py-0 h-auto min-h-0 leading-tight"
          >
            {isExpanded ? core.public.descriptionSection.less : core.public.descriptionSection.more}
            {!isExpanded ? <BiArrowToBottom className="text-sm text-gradient-100" /> : <BiArrowToTop className="text-sm text-gradient-100" />}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default memo(Description);
